import { Fragment } from "react";
import classnames from "classnames";

import style from "./style.module.scss";
import { getProductType } from "../../../product";
import { getShippingPrice } from "../shipping/wilayas";
import type { Product } from "../../../data/api/products";

interface PriceTableProps {
  product: Product;
}

function PriceTable({ product }: PriceTableProps) {
  const productType = getProductType(product.name);
  const shippingPrice = getShippingPrice(product?.shipping?.wilaya);

  if (!productType) {
    return null;
  }

  return (
    <div className={style.container}>
      <h3 className={style.title}>Votre commande</h3>
      <div className={style.items}>
        {productType
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .priceRows(product.options as any, product.promoCode, shippingPrice)
          .map(([label, value], index) => (
            <Fragment key={index}>
              <div className={style.item}>{label}</div>
              <div className={classnames(style.price, style.item)}>{value}</div>
            </Fragment>
          ))}
        <div className={classnames(style.total, style.item)}>
          <strong>Total</strong>
        </div>
        <div className={classnames(style.total, style.item, style.price)}>
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {productType.price(product.options as any, product.promoCode, shippingPrice)} DA
        </div>
      </div>
    </div>
  );
}

export default PriceTable;
